import React, { Component } from 'react';
import { connect } from 'react-redux';
import './updateProfile.scss';
import { Button } from 'antd';
import NoImage from "../../../images/no-image.jpg";
import EditIcon from "../../../images/edit-icon.png";
import { imageEndpoint } from '../../../services/endpoint';
import { uploadIdentityverification, approveRejectIdentifyVerification, approveRejectUserDocument } from '../action/user.actions'

class IdentifyVerification extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  createFormData = (body) => {
    let data = new FormData();
    Object.keys(body).forEach(key => {
      data.append(key, body[key]);
    });
    return data;
  };

  toBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  onSelectFile = (e, document_type) => {
    const { user, dispatch } = this.props;
    let file = e.target.files[0];
    let formData = this.createFormData({
      file: file,
      user_id: user.id,
      document_name: document_type,
      document_type: file.type
    });
    for (var key of formData.entries()) {
      console.log(key[0] + ', ' + JSON.stringify(key[1]));
    }
    dispatch(uploadIdentityverification(user.id, formData))
  }
  approveRejectUserDocument = (id, status) => {
    const {dispatch} = this.props;
    const data = {
      document_id: id,
      status: status
    }
    dispatch(approveRejectUserDocument(data));
  }
  approveRejectIdentifyVerification = (id, status) =>{
    const {dispatch} = this.props;
    const data = {
      user_id: id,
      status: status
    }
    dispatch(approveRejectIdentifyVerification(data));
  }


  render() {
    const { user, userDetails } = this.props;
    const document = (user.identity_verification && user.identity_verification.documents) || [];
    const pan = document.find(d => { return d.document_name == 'Pan' });
    const aadhar = document.find(d => { return d.document_name == 'Aadhar - Front' });
    const driving_license = document.find(d => { return d.document_name == 'Driving License' });
    const voter_id = document.find(d => { return d.document_name == 'Voter Id' });
    const ration_card = document.find(d => { return d.document_name == 'Ration Card' });
    const passport = document.find(d => { return d.document_name == 'Passport' });
    const role = user && user.role && user.role.name
    return (
      <div className="form-main-cont-box">
        <div className="upload-heading-txt">
          Identify Verification
        </div>
        <div className="upload-sub-txt">Upload Minimun 3 document</div>
        <form className="form-container-box">
          <div className="row row-padding">
            <div className="col-sm-12 col-md-4 col-xs-12">
              <div>
                <div className="doc-img-box">
                  <div className="upload-btn-wrapper">
                    <img src={EditIcon} className="doc-edit-icon" alt="" />
                    <input type="file" name="myfile" onChange={(e) => { this.onSelectFile(e, 'Pan') }} />
                  </div>

                  <img src={pan && pan.document_url ? imageEndpoint + pan.document_url : NoImage} className="update-prof-img-box" alt="" />
                 
                </div>
                <label className="redio-lavel-txt">Pan</label>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-xs-12">
              <div>
                <div className="doc-img-box">
                  <div className="upload-btn-wrapper">
                    <img src={EditIcon} className="doc-edit-icon" alt="" />
                    <input type="file" name="myfile" onChange={(e) => { this.onSelectFile(e, 'Aadhar') }} />
                  </div>
                  <img src={aadhar && aadhar.document_url ? imageEndpoint + aadhar.document_url : NoImage} className="update-prof-img-box" alt="" />
                </div>
                <label className="redio-lavel-txt" >Aadhar</label>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-xs-12">
              <div>
                <div className="doc-img-box">
                  <div className="upload-btn-wrapper">
                    <img src={EditIcon} className="doc-edit-icon" alt="" />
                    <input type="file" name="myfile" onChange={(e) => { this.onSelectFile(e, 'Driving License') }} />
                  </div>
                  <img src={driving_license && driving_license.document_url ? imageEndpoint + driving_license.document_url : NoImage} className="update-prof-img-box" alt="" />
                </div>
                <label className="redio-lavel-txt" >Drovind License</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-4 col-xs-12">
              <div>
                <div className="doc-img-box">
                  <div className="upload-btn-wrapper">
                    <img src={EditIcon} className="doc-edit-icon" alt="" />
                    <input type="file" name="myfile" onChange={(e) => { this.onSelectFile(e, 'Voter Id') }} />
                  </div>
                  <img src={voter_id && voter_id.document_url ? imageEndpoint + voter_id.document_url : NoImage} className="update-prof-img-box" alt="" />
                </div>
                <label className="redio-lavel-txt" >Voter Id</label>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-xs-12">
              <div>
                <div className="doc-img-box">
                  <div className="upload-btn-wrapper">
                    <img src={EditIcon} className="doc-edit-icon" alt="" />
                    <input type="file" name="myfile" onChange={(e) => { this.onSelectFile(e, 'Ration Card') }} />
                  </div>
                  <img src={ration_card && ration_card.document_url ? imageEndpoint + ration_card.document_url : NoImage} className="update-prof-img-box" alt="" />
                </div>
                <label className="redio-lavel-txt" >Ratian Card</label>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-xs-12">
              <div>
                <div className="doc-img-box">
                  <div className="upload-btn-wrapper">
                    <img src={EditIcon} className="doc-edit-icon" alt="" />
                    <input type="file" name="myfile" onChange={(e) => { this.onSelectFile(e, 'Passport') }} />
                  </div>
                  <img src={passport && passport.document_url ? imageEndpoint + passport.document_url : NoImage} className="update-prof-img-box" alt="" />
                </div>
                <label className="redio-lavel-txt" >Passport</label>
              </div>
            </div>
          </div>
        </form>
      </div>

    )
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  }
}
export default connect(mapStateToProps)(IdentifyVerification);